// src/hooks/useShifts.js
import { useState, useEffect } from "react";
import Api from "../../Api";

const useShifts = (departmentName) => {
    const [shifts, setShifts] = useState([]);

    useEffect(() => {
        const fetchShifts = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await Api.get(`/deployments/department/${departmentName}/shifts`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setShifts(response.data);
            } catch (error) {
                console.error("Fehler beim Abrufen der Schichten", error);
            }
        };

        fetchShifts();
    }, [departmentName]);

    return [shifts, setShifts];
};

export default useShifts;
